/** Показывает начальную страницу админки */
const DashboardPage = () => {
    return (
        <div>
            <h1>Добро пожаловать в VOX.Manage</h1>
            <p>Выберите раздел в меню слева, чтобы начать работу.</p>
            <ul>
                <li>Управление городами</li>
                <li>Клиенты и адреса</li>
                <li>Услуги для питомцев</li>
                <li>Чаты и отзывы</li>
            </ul>
        </div>
    );
};

export default DashboardPage;